<template>
  <page style="overflow: hidden">
    <!-- <div slot="head" class="page-head-default">
      <img src="../assets/imgs/menu.png" alt="" @click="isMenuView = true">
      {{title}}
    </div> -->
    <div>
      <div class="home-warp" v-if="isScan && cabinet && !isBtns">
        <div class="banner" :style="banner"></div>
        <div class="home-warp-main">
          <div class="home-warp-block"></div>
          <div class="home-warp-cont">
            <div class="home-warp-title">
              <img src="../assets/imgs/map.png" alt="" />
              <span>{{ cabinet.shopname }}</span>
            </div>
            <div class="home-warp-jifei" v-html="priceStrategy(cabinet)"></div>
            <div class="home-warp-row row-desc" v-html="priceInfo || ''"></div>
            <div class="home-warp-row">
              <img src="../assets/imgs/icon_phone.png" alt="" />
              {{ i18n.feature_1 }}
            </div>
            <div class="home-warp-row">
              <img src="../assets/imgs/icon_star.png" alt="" />
              {{ i18n.feature_2 }}
            </div>
            <div class="home-warp-row">
              <!-- <img src="../assets/imgs/icon_tag.png" alt=""> -->
              {{ shopDesc }}
            </div>
          </div>
          <div class="home-warp-btn">
            <!-- <div class="home-warp-btn" v-if="cabinet.chongzhi === 'Y'"> -->
            <!-- <div class="home-warp-tips">
              <img src="../assets/imgs/icon_info.png" alt="" />
              <span>{{ shopTips1 }}</span>
            </div> -->
            <div
              class="btn"
              v-if="cabinet.yajintype === 0 && cabinet.yajin > 0"
              @click="onSubmit"
            >
              {{ i18n.preauth }} {{ cabinet.currencyName }}{{ amount }}
              {{ cabinet.currency }}
            </div>
            <div v-else class="btn" @click="onSubmit">
              {{ i18n.borrow }} {{ cabinet.currencyName }}{{ amount }}
              {{ cabinet.currency }}
            </div>
          </div>
          <!-- <div class="home-warp-btn" v-else>
            <div class="home-warp-tips">
              <img src="../assets/imgs/icon_info.png" alt="" />
              <span>{{ shopTips3 }}</span>
            </div>
            <!- <div class="btn" @click="onBorrow">{{ i18n.borrow }}</div> ->
          </div> -->
        </div>
      </div>

      <div v-else>
        <img
          class="home-circular"
          src="../assets/imgs/img_circular.png"
          alt=""
          @click="isMenuView = true"
        />
        <img
          class="home-logo"
          src="../assets/imgs/logo1.png"
          alt=""
          @click="isMenuView = true"
        />
        <h3 class="joinus" @click="goWebSite">{{ i18n.joinus }} ></h3>
        <img
          class="home-newpower"
          src="../assets/imgs/new_powrbank_phone.png"
          alt=""
        />
        <!-- <img class="home-schalte" src="../assets/imgs/schalte.png" alt=""> -->
        <div class="home-schalte">{{ i18n.unlock_powerbank }}</div>
        <div class="home-btnicon">
          <div v-if="code" class="home-gradient-btn" @click="onCode">
            {{ i18n.start_renting }}
          </div>
          <div class="home-gradient-btn" @click="onDownload">
            {{ i18n.download }}
          </div>
        </div>
        <div class="home-appstore">
          <img
            alt=""
            @click="onAppStore"
            src="../assets/imgs/apple_store.png"
          />
          <img
            alt=""
            @click="onGooglePlay"
            src="../assets/imgs/google_play.png"
          />
        </div>
        <div class="localelang" @click="isLangView = true">
          <img :src="localeImg" alt="" />
          <span>{{ locale && locale.label }}</span>
        </div>
        <!-- <div class="home-foot">
          <div class="home-btns">
            <a v-if="system === 'ios'" style="background: #000;" :href="appleUrl">
              <img src="../assets/imgs/apple.png" alt="">
              <span>App Store</span>
            </a>
            <a v-else style="background: #000;" :href="googleUrl">
              <img src="../assets/imgs/google.png" alt="">
              <span>Google Play</span>
            </a>
            <a v-if="code" @click="onCode" style="background: #fff; color: #000; border: 1px solid #000;">
              <span>{{i18n.goborrow}}</span>
            </a>
          </div>
        </div> -->
      </div>
    </div>
    <popup-warp v-model="isMenuView" dialogTransition="slide-left">
      <menu-side></menu-side>
    </popup-warp>
    <select-lang v-model="isLangView"></select-lang>
  </page>
</template>

<script>
import { SelectLang } from "../components/select"
import { PopupWarp } from "../components/popup"
import { MenuSide } from "../components/menu"
import { mapState, mapGetters } from "vuex"
import { QR_CODE, ZH_CODE, ORDER_TEMP } from "../apis/cabinet"
import { USER_CARD, SAVED_CARD_RENT, BALANCE_RENT } from "../apis/payment"
import { USER_INFO, TOURIST_LOGIN } from "../apis/user"
import DE from "@/assets/imgs/de-DE.png"
import US from "@/assets/imgs/en-US.png"
export default {
  components: {
    PopupWarp,
    MenuSide,
    SelectLang
  },
  computed: {
    ...mapState(["qrcode", "zhcode", "cabinet", "browser", "user", "system"]),
    ...mapGetters(["locale"]),
    i18n() {
      return this.$t("home")
    },
    i18nMsg() {
      return this.$t("msg")
    },
    title() {
      return process.env.VUE_APP_NAME
    },
    code() {
      return this.qrcode || this.zhcode
    },
    scanUrl() {
      if (this.qrcode) {
        return `${QR_CODE}?id=${this.qrcode}&usePriceUnit=true`
      }
      if (this.zhcode) {
        return `${ZH_CODE}/${this.zhcode}`
      }
      return ""
    },
    banner() {
      return this.cabinet && this.cabinet.shoplogo
        ? `background-image: url(${this.cabinet.shoplogo});`
        : ""
    },
    shopDesc() {
      return `${this.i18n.shopdesc}`.format(this.cabinet)
    },
    priceInfo() {
      return `${this.i18n.price_info}`.format(this.cabinet)
    },
    shopTips1() {
      return `${this.i18n.tips_1}`.format(this.cabinet)
    },
    shopTips2() {
      return `${this.i18n.tips_2}`.format(this.cabinet)
    },
    shopTips3() {
      return `${this.i18n.tips_3}`.format(this.cabinet)
    },
    amount() {
      if (this.cabinet) {
        return (this.cabinet.yajin - this.cabinet.myyue).toFixed(2)
      } else {
        return 0
      }
    },
    appleUrl() {
      return process.env.VUE_APP_APP_STORE
    },
    googleUrl() {
      return process.env.VUE_APP_GOOGLE_PLAY
    },
    localeImg() {
      return this.locale.value === "de-DE" ? DE : US
    }
  },
  data() {
    return {
      isMenuView: false,
      isScan: false,
      isBtns: false,
      cardList: [],
      isLangView: false
    }
  },
  methods: {
    goWebSite() {
      let domain = process.env.VUE_APP_DOMAIN
      domain = domain.replace("m.", "www.")
      window.location.href = domain
    },
    getCardList() {
      this.$loading(true)
      this.$get(
        `${USER_CARD}`,
        {
          qrcode: this.code
        },
        (resp) => {
          this.$loading(false)
          console.log("cardlist", resp)
          this.cardList = resp.data
        },
        (error) => {
          this.$loading(false)
          // this.$confirm({
          //   title: this.i18n.msg_fail_title,
          //   content: this.i18nMsg.error,
          //   confirmText: this.i18nMsg.retry,
          //   cancelText: this.i18nMsg.cancel
          // }).then(() => {
          //   this.getCardList()
          // })
          console.log(error)
        }
      )
    },
    onScan() {
      if (!this.scanUrl) return
      this.$loading(true)
      this.$post(
        this.scanUrl,
        {},
        (resp) => {
          this.$loading(false)
          this.$store.commit("cabinet", {
            qrcode: this.code,
            ...resp
          })
          if (resp.zujieNum && resp.zujieNum > 0) {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: `${this.i18n.msg_rentcount}`.format(resp),
              confirmText: this.i18nMsg.vieworder,
              cancelText: this.i18nMsg.cancel
            })
              .then(() => {
                this.$router.push("/order")
                this.$store.commit("qrcode", "")
              })
              .catch(() => {
                this.$store.commit("qrcode", "")
              })
          } else {
            this.isScan = true
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    onSubmit() {
      if (
        this.cabinet.myyue >= this.cabinet.yajin &&
        this.cabinet.myyue >= this.cabinet.overtimeAmount
      ) {
        this.onBorrow()
      } else if (this.cabinet.yajin === 0 && this.cabinet.overtimeAmount > 0) {
        if (this.cardList && this.cardList.length > 0) {
          this.onCardBorrow()
        } else {
          this.$router.push({ path: "/payment_card", query: { payType: "YJ" } })
        }
      } else if (
        this.cabinet.yajin > 0 &&
        this.cabinet.overtimeAmount > 0 &&
        this.cabinet.overtimeAmount > this.cabinet.yajin
      ) {
        if (this.cardList && this.cardList.length > 0) {
          this.$router.push({
            path: "/confirm",
            query: { price: this.amount, payType: "YJ", cabinetID: this.qrcode }
          })
        } else {
          this.$router.push({ path: "/payment_card", query: { payType: "YJ" } })
        }
      } else {
        this.$router.push({
          path: "/confirm",
          query: { price: this.amount, payType: "YJ", cabinetID: this.qrcode }
        })
      }
    },
    onCardBorrow() {
      this.$loading(true)
      this.$get(
        `${SAVED_CARD_RENT}?qrcode=${this.qrcode}`,
        {},
        (resp) => {
          this.$loading(false)
          console.log(resp)
          if (resp.data.out_trade_no) {
            this.$router.push(`/result?tradeNo=${resp.data.out_trade_no}`)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            })
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    onBorrow() {
      this.$loading(true)
      this.$get(
        `${BALANCE_RENT}?qrcode=${this.cabinet.qrcode}`,
        {},
        (resp) => {
          this.$loading(false)
          console.log(resp)
          if (resp.data.outTradeNo) {
            this.$router.push(`/result?tradeNo=${resp.data.outTradeNo}`)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            })
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    loadUser() {
      this.$get(
        USER_INFO,
        {},
        (resp) => {
          if (resp.user) {
            this.$store.commit("user", resp.user)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user,
              confirmText: this.i18nMsg.retry,
              cancelText: this.i18nMsg.cancel
            }).then(() => {
              this.loadUser()
            })
          }
        },
        (error) => {
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.loadUser()
          })
          console.log(error)
        }
      )
    },
    onDownload() {
      if (this.system === "ios") {
        this.onAppStore()
      } else {
        this.onGooglePlay()
      }
    },
    onAppStore() {
      window.location.href = process.env.VUE_APP_APP_STORE
    },
    onGooglePlay() {
      window.location.href = process.env.VUE_APP_GOOGLE_PLAY
    },
    onCode() {
      if (this.user) {
        this.isBtns = false
        this.loadUser()
        this.onScan()
      } else {
        this.$router.push("/login")
      }
    },
    loginTourist() {
      this.$post(
        `${TOURIST_LOGIN}?code=${this.code}`,
        {},
        (resp) => {
          if (resp.token) {
            this.$store.commit("token", resp.token)
            this.loadUser()
          }
        },
        (error) => {
          console.log(error)
        }
      )
    },
    // 价格策略
    priceStrategy(cabinet = {}) {
      const strategy = cabinet.priceStrategy || {}
      let keepT = this.i18n.minute
      // 计时 pPriceMinute  单位 priceUnit 0-分钟 1-小时 2-天
      if (strategy.priceUnit === 1) {
        keepT = this.i18n.hour
      } else if (strategy.priceUnit === 2) {
        keepT = this.i18n.days
      }
      const price = `<span>${cabinet.jifei + cabinet.currencyName}</span>`
      return `${strategy.pPriceMinute} ${keepT} / ${price}`
    }
  },
  created() {
    let qrCode = this.qrcode || this.$route.query.qrcode
    console.log("qrCode", qrCode)
    if (qrCode) {
      this.$store.commit("qrcode", qrCode)
      if (this.user) {
        this.getCardList()
        this.onCode()
      } else {
        this.loginTourist()
        // this.$router.push('/login')
      }
    }
  }
}
</script>

<style lang="less">
.home-warp {
  .banner {
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    background-color: #fff;
    background: url("../assets/imgs/banner-home.jpg") no-repeat center;
    background-size: cover;
  }

  &-main {
    width: 100%;
    height: calc(100vh - 424px);
    position: fixed;
    bottom: 0;
    left: 0;
    background: #ffffff;
    border-radius: 40px 40px 0 0;
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.1);
  }

  &-block {
    display: flex;
    justify-content: center;
    align-items: center;

    &::after {
      content: " ";
      height: 8px;
      width: 80px;
      margin: 20px;
      border-radius: 4px;
      background: #cccccc;
    }
  }

  &-cont {
    padding: 0 48px;
  }

  &-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
  }

  &-jifei {
    padding: 60px 0 20px;
    font-size: 36px;
    font-weight: 600;

    span {
      font-size: 60px;
    }
  }

  &-row {
    display: flex;
    font-size: 24px;
    line-height: 32px;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 0;
    color: #999999;

    img {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
  }

  .row-desc {
    line-height: 1.4;
    color: #333;
    font-size: 34px;
    font-weight: 600;
  }

  &-btn {
    position: fixed;
    left: 48px;
    right: 48px;
    bottom: 48px;

    button {
      width: 100%;
      border: none;
      padding: 0;
      margin: 0;
    }
  }

  &-tips {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 40px;
    font-size: 28px;
    color: #666666;
    padding: 20px 0;

    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
}

.home-bg {
  width: 60%;
  display: block;
  margin: 0px auto;
  // height: 100vh;
}

.home-btns {
  width: 100%;
  display: flex;
  position: fixed;
  bottom: 40px;
  justify-content: center;
  flex-direction: row;
  text-align: center;
  z-index: -1;

  a {
    text-decoration: none;
    width: 30%;
    flex: 1;
    margin: 20px;
    background: #000000;
    color: #ffffff;
    padding: 20px 0;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
}

.home-warp2222 {
  .banner {
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    background-color: #fff;
    background: url("../assets/imgs/banner-home.jpg") no-repeat center;
    background-size: cover;
  }
  &-main {
    width: 100%;
    height: calc(100vh - 454px);
    position: fixed;
    bottom: 0;
    left: 0;
    background: #ffffff;
    border-radius: 40px 40px 0 0;
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.1);
  }
  &-block {
    display: flex;
    justify-content: center;
    align-items: center;
    &::after {
      content: " ";
      height: 8px;
      width: 80px;
      margin: 20px;
      border-radius: 4px;
      background: #cccccc;
    }
  }
  &-cont {
    padding: 0 48px;
  }
  &-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
  }
  &-jifei {
    width: 80%;
    margin: 0 auto 60px;
    padding: 60px 0 20px;
    font-size: 36px;
    font-weight: 600;
    text-align: center;
    border-bottom: #9d2bf3 solid 6px;
    span {
      font-size: 60px;
    }
  }
  &-row {
    // display: flex;
    font-size: 28px;
    text-align: center;
    line-height: 42px;
    // justify-content: flex-start;
    // align-items: center;
    font-family: "Montserrat-Regular";
    padding: 8px 0;
    color: #000000;
    img {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
  }
  &-btn {
    position: fixed;
    left: 48px;
    right: 48px;
    bottom: 108px;
    font-family: "Montserrat-Regular";
    button {
      width: 100%;
      border: none;
      padding: 0;
      margin: 0;
    }
  }
  &-tips {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 40px;
    font-size: 28px;
    color: #666666;
    padding: 20px 0;
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
}
.home-circular {
  width: 40%;
  display: block;
}
.home-logo {
  position: absolute;
  top: 52px;
  left: 20px;
  width: 30%;
}
.joinus {
  width: max-content;
  position: absolute;
  top: 50px;
  right: 40px;
  margin: 0;
  color: #9d2bf3;
}
.home-newpower {
  width: 60%;
  margin: -60px auto 0;
  display: block;
  border-radius: 32px;
}
.home-schalte {
  margin: 20px 0;
  text-align: center;
  font-size: 40px;
  color: #000;
  font-weight: 900;
}
.home-btnicon {
  width: 60%;
  margin: 60px auto 0;
  img {
    width: 100%;
    margin-top: 20px;
  }
  .home-gradient-btn {
    margin-top: 20px;
    width: 100%;
    text-align: center;
    font-size: 36px;
    height: 88px;
    line-height: 88px;
    border-radius: 44px;
    color: #fff;
    background: radial-gradient(ellipse, #b121bf 0%, #9d2bf3 85%);
  }
}
.home-appstore {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  img {
    width: 30%;
  }
}
.localelang {
  width: max-content;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  background: #9d2bf3;
  color: #fff;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 60px;
    margin: 0 20px 0 10px;
  }
}
.home-btns {
  width: 100%;
  display: flex;
  position: fixed;
  bottom: 40px;
  justify-content: center;
  flex-direction: row;
  text-align: center;
  z-index: -1;
  a {
    text-decoration: none;
    width: 30%;
    flex: 1;
    margin: 20px;
    background: #000000;
    color: #ffffff;
    padding: 20px 0;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
}
.home-foot {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  .nearby {
    position: absolute;
    bottom: 170px;
    right: 20px;
    color: #fff;
    text-decoration: underline;
    text-align: center;
  }
}
</style>
